// Live
let url = "https://www.heydesk.online/";
let phpHost_url = `${url}locations/`;
let phpHost = `${url}WEB_API/`;
let googleId =
  "955212842306-96edlsst4n3aoglsbtlmsspc351v6klk.apps.googleusercontent.com";
let facebookId = "1426586414184110";
let linkedinId = "75zh3tgae70abz";
let linkedinUri = `${url}linkedin`;

// Localhost
if (
  window.location.hostname === "localhost" ||
  window.location.hostname === "192.168.0.180"
) {
  url = `http://${window.location.hostname}:3000/`;
  phpHost_url = `${url}locations/`;
  phpHost = `http://${window.location.hostname}/heydesk.com/WEB_API/`;
  googleId =
    "698183793373-dnt17vtgec8eh3nnf6ho14i1bccablo6.apps.googleusercontent.com";
  facebookId = "756660354854487";
  linkedinId = "75zh3tgae70abz";
  linkedinUri = `${url}linkedin`;
}

// common
let googleMapsApiKey = "AIzaSyD3Uu4Ib-bl3A8Tbf3RLacBc1PjCNOcn0k";
let s3BucketPath = "https://hd-media-007.s3.eu-west-1.amazonaws.com/";

export default {
  url,
  phpHost,
  phpHost_url,
  googleId,
  facebookId,
  linkedinId,
  linkedinUri,
  googleMapsApiKey,
  s3BucketPath
};
